import React from 'react';
import { Navigate } from 'react-router-dom';
import { getToken } from '../services/authService';

export const PrivateRoute = ({ children }) => {
    const token = getToken();
    
    if (!token) {
        // Nicht eingeloggt, Weiterleitung zur Login-Seite
        return <Navigate to="/login" replace />;
    }

    // Eingeloggt, zeige geschützte Route
    return children;
}; 